export const ApiRoute = {
  get_companies: "/api/v1/data_dependency/user_companies",
  get_phone_codes: "/api/v1/data_dependency/country_phone_codes",
  get_phone_codes_profile: "/api/v1/phonecodes.json?per_page=1000",
  get_countries: "/api/v1/data_dependency/countries",
  get_country_states: "/api/v1/data_dependency/country",
  get_country_state_cities: "/api/v1/data_dependency/country",
  get_services_type: "/api/v1/data_dependency/service_types",
  get_commodities: "/api/v1/data_dependency/commodities",
  get_package_types: "/api/v1/data_dependency/package_types",
  get_currencies: "/api/v1/data_dependency/currencies",
  get_add_ons: "/api/v1/data_dependency/addons",
  get_insurance_types: "/api/v1/data_dependency/insurance_types",
  check_users_complete: "/api/v1/data_dependency/users_autocomplete",
  get_dimension_units: "/api/v1/data_dependency/measurement_units_v1",
  //add_order: "/api/v1/orders",
  get_order_list: "/api/v1/orders?page=",
  get_order_list_csv: "/api/v1/orders.csv",
  get_bulk_order_list:"/api/v1/bulk_orders",
  get_order_detail: "/api/v1/order_trackings",
  get_order_detail_for_anonymous_user: "/api/v1/order_anonymous",
  post_bulk_orders: "/api/v1/bulk_orders",
  get_bulk_orders: "/api/v1/bulk_orders/",
  get_agent_detail: "/api/v1/data_dependency/user_location/",
  get_order_status: "/api/v1/data_dependency/statuses",
  get_order_booking_modes: "/api/v1/data_dependency/booking_modes",
  get_orders_tab_count: "/api/v1/orders/order_count.json",

  tag_suggestion: "/api/v1/data_dependency/tags_autocomplete?name=",
  get_timezones: "/api/v1/data_dependency/list_timezones",
  get_shipments: "/api/v1/shipments/active.json",
  get_hub_package_details: "/api/v1/orders/:orderId.json",
  get_package_activities: "/api/v1/shipment_trackings/:shipmentId/activities.json",
  get_package_activities_for_anonymous_user: "/open_api/v1/shipments/:shipmentId/activities.json",
  // get_package_activities: "/api/v1/shipments/:shipmentId/activities",
  get_hub_package_basic_details: "/api/v1/shipments/:shipmentId.json",
  get_dashboard: "/api/v1/shipment_trackings/shipment_count",

  get_flat_states: "/api/v1/data_dependency/flat_states",
  get_flat_cities: "/api/v1/data_dependency/flat_cities",

  // maps
  map_level1: "/api/v1/orders/map_view_lvl_1",
  map_level2: "/api/v1/orders/map_view_lvl_2",
  // get_unifed_filter_data_order: "/api/v1/data_dependency/unified_filters_data",
  // get_unifed_filter_data_shipment: "/api/v1/dependencies/user_locations",

  // tracking
  verifyTrackingIds: "/open_api/v1/shipments/tracking.json",
  verifyTrackingIdsForLoggedIn: "/api/v1/shipment_trackings/tracking",
  getTrackingActive: "/api/v1/shipment_trackings/active.json",
  getTrackingComplete: "/api/v1/shipment_trackings/completed.json",
  getTrackingAnonymousUserActive: "/open_api/v1/shipments/active.json",
  getTrackingAnonymousUserComplete: "/open_api/v1/shipments/completed.json",
  getShipmentCountAnonymousUser: "/open_api/v1/shipments/shipment_count.json",
  removeTracking: "/api/v1/shipment_trackings/remove_tracking",
  getInstructions: "/api/v1/shipment_instructions/leave_parcel_list",
  postInstruction: "/api/v1/shipment_trackings/:shipmentId/shipment_instructions",

  // auth
  logout: "/api/v1/users/logout",
  getProfile: "/api/v1/users/get_my_profile.json",
  getUserDetail: "/api/v1/users/{user.id}.json",
  updateUserDetail: "/api/v1/users/update_my_profile.json",
  getCustomerPortalPermission: "/api/v1/qchoices/customer_portal",
  getTimezones: "/api/v1/timezones/available.json",
  getCurrencies: "/api/v1/currencies.json",
  changeUserPreferences: "/api/v1/users/change_user_preferance.json",
  getEmailOtp: "/api/v1/users/send_email_otp_code?email={email}",
  getPhoneNumberOtp: "/api/v1/users/send_mobile_otp_code?mobile_phonecode_id={phoneCodeId}&mobile_no={mobileNo}",
  verifyEmailOtp: "/api/v1/users/verify_email_otp_code?otp={otp}",
  verifyPhoneNumberOtp: "/api/v1/users/verify_mobile_otp_code?otp={otp}",
  updatePassword: "/api/v1/users/update_password.json",

  // order
  printWayBill: "/api/v1/orders/{order.id}/waybill.pdf",
  printLabel: "/api/v1/orders/{order.id}/shipping_labels.pdf",
  printCN22: "/api/v1/orders/{order.id}/cn22.pdf",
  printCN23: "/api/v1/orders/{order.id}/cn23.pdf",
  getTrackingUrl: "/api/v1/orders/tracking_url?id={id}",
  getOrderDetails: "/api/v1/orders/{order.id}",
  addOrder: "/api/v1/orders",
  getBulkOrder:"/api/v1/bulk_orders/",
  downloadCSVTemplate: "/api/v1/bulk_orders/new",
  getDestination: "/api/v1/data_dependency/order_destination_locations",
  getOrigin: "/api/v1/data_dependency/order_origin_locations",
  getCustomerTypeOptions: "/api/v1/data_dependency/customer_types",
  getStatusOptions: "/api/v1/data_dependency/bulk_order_statuses",
  getColumnSetting: "/api/v1/column_settings",
  bulkOrderPrintLabel: "/api/v1/bulk_orders/{order.id}/shipping_labels.pdf",
  bulkOrderPrintWayBill: "/api/v1/bulk_orders/{order.id}/waybills.pdf",
  CN22BulkOrder: "/api/v1/bulk_orders/{order.id}/cn22s.pdf",
  CN23BulkOrder: "/api/v1/bulk_orders/{order.id}/cn23s.pdf",
  fetchErrorsFileBulk: "/api/v1/bulk_orders/{id}",
  fetchViewFile: "/api/v1/bulk_orders/{id}/file_content",
  retryFile: "/api/v1/bulk_orders/{id}/proceed",
  deleteAutocompleteUser: "/api/v1/stored_contacts/",
  fetchOrganisationPrintLabelsList: "/api/v1/data_dependency/organisation_labels",
  get_sla_services_type: "/api/v1/shipping/services",
  getEPOPNonLogin: "/open_api/v1/orders/epod_image",
  sendTrackingURLEmail: "/api/v1/orders/send_tracking_url?id={id}&email={email}",
  retryCreateOrder: "/api/v1/orders/{orderId}/retry_create",

  // shipment hold and release
  holdAndRelease : "/api/v1/shipment_trackings/:id/hold_and_release",

  //qchoices
  get_tracking_id_anonymous:"/open_api/v1/shipments/tracking_list",
  get_inbound: "/api/v1/qchoices/trackings/active_inbound",
  get_outbound: "/api/v1/qchoices/trackings/active_outbound",
  get_inbound_map:"/api/v1/qchoices/trackings/full_map_inbound",
  get_outbound_map:"/api/v1/qchoices/trackings/full_map_outbound",
  deleteOrder: "/api/v1/orders",
  get_history_inbound_count: "/api/v1/shipment_trackings/inbound_count",
  get_history_outbound_count: "/api/v1/shipment_trackings/outbound_count",
  get_history_inbound: "/api/v1/shipment_trackings/inbound_history",
  get_history_outbound: "/api/v1/shipment_trackings/outbound_history",
  fetchPricingDetails: "/api/v1/pricing/pricing_options",
  checkPricingModuleAvailability: "/api/v1/pricing/module_enabled",
  //detail
  get_map_detail: "/api/v1/shipments/:shipmentId/order_detail_map_view",
  gps_map_detail: "/api/v1/vehicle/gps_tracking?order_id=:orderId&job_type=:jobType",
  gps_map_detail_non_login: "/open_api/v1/vehicle/gps_tracking?order_id=:orderId&job_type=:jobType",

  // logo
  getLogoNonLogin: "/api/v1/organisations/qship_org_logo.json?organisation_code={organisation}",
  // i18-language
  get_all_languages: "/api/v1/locales",

  //qship
  tracking_inbound: "/api/v1/trackings/inbound",
  tracking_outbound: "/api/v1/trackings/outbound",
  history_inbound: "/api/v1/history/inbound",
  history_outbound: "/api/v1/history/outbound",
  verify_non_login_trackingIds: "/open_api/v1/orders/tracking",
  tracking_non_login: "/open_api/v1/orders",
  verify_secure_trackingIds: "/open_api/v1/secure_orders/tracking",
  tracking_secure: "/open_api/v1/secure_orders",
  getOrderSegments: "/api/v1/segments?order_id={orderId}",
  getOrderSegmentsNonLogin: "/open_api/v1/segments?order_id={orderId}",
  getGPSTracking: "/api/v1/segments/gps_tracking?id={segmentId}",
  getOrderActivities: "/api/v1/orders/{orderId}/activities.json",
  getOrderActivitiesUnauthenticated: "/open_api/v1/orders/{orderId}/activities.json",
  downloadExportedFile: "/api/v1/export/{id}/download",
  getExportingFileStatus: "/api/v1/export/{id}/status",
  sendExportedFileViaMail: "/api/v1/export/{id}/send_mail",

  // open api
  getRegisteredOrganisations: "/api/open_api/v1/organisations/find.json",

  // convert API
  getCurrencyExchange: "/api/v1/data_dependency/exchange_rate_converted",
  getMeasurementExchange:"/api/v1/data_dependency/measurement_units_converted",

  // login
  login: "/api/v1/users/login",
  loginV2: "/api/v2/users/login",
  loginV3: "/api/v3/users/login",
  refreshToken: "/api/v3/users/refresh_token",
};
